import Axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import { axiosApiInstance } from '@/lib/axios/axiosClient';

export const customInstance = <T>(
  config: AxiosRequestConfig,
): Promise<AxiosResponse<T>> => {
  const source = Axios.CancelToken.source();
  const promise = axiosApiInstance({
    ...config,
    cancelToken: source.token,
  });

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  promise.cancel = () => {
    source.cancel('Query was cancelled by React Query');
  };

  return promise;
};

export default customInstance;

export type ErrorType<Error> = AxiosError<Error>;
